import _Paper from "@material-ui/core/esm/Paper";
import React from 'react';
import classNames from 'classnames';
import { GiveawayGoodieSteps } from 'swag-common/interfaces';
import { ButtonType } from 'swag-client-common/components/ui/button/button';
import { Button } from 'swag-client-common/components/ui/button/button';
import { GiveawayButtonEntered } from 'swag-client-common/components/partials/giveaway/giveaway-button-entered/giveaway-button-entered';
import classes from './submit-block.scss';
import { CatalogScrollContinueBlock } from './catalog-scroll-continue-block';
const paperClasses = {
  root: classes.paper
};
export const SubmitBlock = ({
  primaryColor,
  disabled,
  step,
  onSubmit,
  onBack,
  giveawayTypeLabel,
  tooltipErrorMessage
}) => {
  const handleSubmit = () => {
    if (disabled) {
      return;
    }
    onSubmit();
  };
  const renderSubmitButton = ({
    name,
    isGoodieCheckout
  }) => {
    return /*#__PURE__*/React.createElement(GiveawayButtonEntered, {
      type: ButtonType.primary,
      disabled: disabled,
      onClick: handleSubmit,
      dataButton: name,
      className: classNames(classes.button, {
        [classes.disabled]: disabled,
        [classes.goodieCheckout]: isGoodieCheckout
      }),
      style: {
        backgroundColor: primaryColor,
        borderColor: primaryColor
      },
      tooltipErrorMessage: tooltipErrorMessage
    }, name);
  };
  const renderBackButton = () => /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    type: "defaultGrey",
    onClick: onBack,
    dataButton: "Back",
    className: classNames(classes.button, classes.goodieCheckout)
  }, "Back"));
  const renderContent = () => {
    switch (step) {
      case GiveawayGoodieSteps.checkout:
        {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
            className: classes.text
          }, "We\u2019re almost there! Once you submit your order, we\u2019ll start getting your", ' ', giveawayTypeLabel, " package ready for you!"), /*#__PURE__*/React.createElement("div", {
            className: classes.buttonSection
          }, renderBackButton(), renderSubmitButton({
            name: 'Submit',
            isGoodieCheckout: true
          })));
        }
      case GiveawayGoodieSteps.catalog:
        {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CatalogScrollContinueBlock, {
            submitButton: renderSubmitButton({
              name: 'Continue'
            })
          }), /*#__PURE__*/React.createElement("p", {
            className: classes.text
          }, "Amazing! We just have a few more steps to confirm your order and shipping address!"), /*#__PURE__*/React.createElement("div", {
            className: classes.buttonSection
          }, renderSubmitButton({
            name: 'Continue'
          })));
        }
      default:
        return renderSubmitButton({
          name: 'Submit'
        });
    }
  };
  return /*#__PURE__*/React.createElement(_Paper, {
    classes: paperClasses
  }, renderContent());
};